import { ChangeDetectorRef, Component, OnInit,OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { VendorService } from '../shared/vendor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';
import { StateNames } from '../models/vendor.model';
import { merge, Subscription } from 'rxjs';

@Component({
  selector: 'app-non-enumerated-individual-details',
  templateUrl: './non-enumerated-individual-details.component.html',
  styleUrls: ['./non-enumerated-individual-details.component.css','../shared/css/common.css']
})
export class NonEnumeratedIndividualDetailsComponent implements OnInit, OnDestroy {

  nonEnumeratedIndividualFormData: any;
  formdata: any | null;
  payorkey: number;
  title: string = "Provider";
  isformloaded = false;
  isInstruction = false;
  instructionText!: string | null;

  nonEnumeratedIndividualFormData1: any = {};
  nonEnumeratedIndividualFormData2: any = {};
  internalInvolvedPartiesKey = 0;
  isNameRequired = false;
  isRequiredIdLabelVisible = false;
  isFormsValid = false;
  statelist: StateNames[] = [];
  primaryColor?: string = "";

  nonEnumeratedIndividualFormPart1: FormGroup;
  nonEnumeratedIndividualFormPart2: FormGroup;
  private nameSubscription?: Subscription;
  private stateSubscription?: Subscription;
  private formSubscription?: Subscription;
  private initCount = 0;

  constructor(
    private providerFormBuilder: FormBuilder,
    private router: Router,
    private vendorService: VendorService,
    private cdref: ChangeDetectorRef,
    private modalService: NgbModal
  ) {
    this.formdata = JSON.parse(sessionStorage.getItem("activeformdata") ?? "{}");
    this.nonEnumeratedIndividualFormData = this.formdata.nonEnumeratedIndividualDetails;
    this.nonEnumeratedIndividualFormData1["controls"] = this.formdata.nonEnumeratedIndividualDetails.controls.slice(0, 11);
    this.nonEnumeratedIndividualFormData2["controls"] = this.formdata.nonEnumeratedIndividualDetails.controls.slice(11, 21);
    this.payorkey = parseInt(sessionStorage.getItem("payorkey") ?? "0");
    this.nonEnumeratedIndividualFormPart1 = this.providerFormBuilder.group({});
    this.nonEnumeratedIndividualFormPart2 = this.providerFormBuilder.group({});
    this.nonEnumeratedIndividualFormData1.controls.forEach((ctrl: any) => {
    this.nonEnumeratedIndividualFormPart1.addControl(ctrl.name, this.providerFormBuilder.control(ctrl.value, []) );
    });
    this.nonEnumeratedIndividualFormData2.controls.forEach((ctrl: any) => {
    this.nonEnumeratedIndividualFormPart2.addControl( ctrl.name, this.providerFormBuilder.control(ctrl.value, []));
    });
  }

  ngOnInit(): void {
    const involvedCtrl = this.formdata.witnessDetails.controls.find((x: any) => x.name == "involvedType");
    if (involvedCtrl?.value) {
      this.internalInvolvedPartiesKey = involvedCtrl.value;
      this.title = involvedCtrl.options.find((y: any) => y.value == involvedCtrl.value)?.key ?? "Provider";
    }

    this.vendorService.getLeadHeaders(this.payorkey).subscribe(result => {
      this.isInstruction = result.IsInstructionEnbaled;
      let instructionText = result.Instruction?.replace('<img ', '<img title="Header" ');
      this.instructionText = instructionText;
    });
  this.vendorService.getStateNames().subscribe(result => {
    this.statelist = result;

    const stateConfig = this.nonEnumeratedIndividualFormData.controls.find( (x: any) => x.name === "neiState");
    if (!stateConfig) return;
    stateConfig.options = result.map(x => ({ value: x.Abbreviation, key: x.Name }));

    const savedState = stateConfig.value;
    const savedCounty = this.nonEnumeratedIndividualFormData.controls.find((x: any) => x.name === "neiCounty")?.value;

    if (savedState) {
      setTimeout(() => {
        const stateCtrl = this.nonEnumeratedIndividualFormPart2.get('neiState');
        if (stateCtrl) {
          (stateCtrl as any).setValue(savedState);
        }

        this.vendorService.getStateCounties(savedState).subscribe(countyResult => {
          const countyConfig = this.nonEnumeratedIndividualFormData.controls.find((x: any) => x.name === "neiCounty");
          if (countyConfig) {
            const counties = countyResult.map((x: any) => ({ key: x.County, value: x.County }));
            countyConfig.options = counties;
            countyConfig.disabled = false;

            if (savedCounty && savedCounty) {
              setTimeout(() => {
                const countyCtrl = this.nonEnumeratedIndividualFormPart2.get('neiCounty');
                if (countyCtrl) {
                  (countyCtrl as any).setValue(savedCounty);
                  countyConfig.value = savedCounty;
                }
              }, 50);
            }
          }
        });
      }, 50);
    }
  });

    this.vendorService.getSubjectRequiredFieldsByInvolvedParty(this.internalInvolvedPartiesKey, this.payorkey).subscribe(result => {
      if(result.EitherOrOptions == 1)
        {
        this.isNameRequired = true;
        }        
          const markReq = (ctrlName: string, required: boolean) => {
          const ctrl = this.nonEnumeratedIndividualFormData1.controls.find((x: any) => x.name === ctrlName)
            || this.nonEnumeratedIndividualFormData2.controls.find((x: any) => x.name === ctrlName);

          if (ctrl) ctrl.validators.required = required;
        };
        markReq("neiAssociatedOrg", !!result.AssociatedOrganizationName);
        markReq("neiFirstName", !!result.FirstName);
        markReq("neiLastName", !!result.LastName);
        markReq("neiMiddleName", !!result.MiddleName);
        markReq("neiDateOfBirth", !!result.DateofBirth);
        markReq("neiSsn", !!result.SSN);
        markReq("neiOtherId", !!result.OtherID);
        markReq("neiStreetAddress1", !!result.AddressLine1);
        markReq("neiCity", !!result.City);
        markReq("neiState", !!result.State);
        markReq("neiCounty", !!result.County);
        markReq("neiZip", !!result.ZipCode);
        markReq("neiCountry", !!result.Country);
        markReq("neiPrimaryPhone", !!result.Phone);
        markReq("neiSecondaryPhone", !!result.SecondaryPhone);
        markReq("neiEmail", !!result.Email);

        const emailCtrl = this.nonEnumeratedIndividualFormPart1.get('neiEmail') || this.nonEnumeratedIndividualFormPart2.get('neiEmail');
          if (emailCtrl) {
            if (result.Email) {
              emailCtrl.setValidators([ Validators.required, Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)
              ]);
            } else {
              emailCtrl.setValidators([ Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)
              ]);
            }
            emailCtrl.updateValueAndValidity({ emitEvent: false });
          }

        const ssnCtrl = this.nonEnumeratedIndividualFormPart1.get('neiSsn') || this.nonEnumeratedIndividualFormPart2.get('neiSsn');
          if (ssnCtrl) {
            if (result.SSN) {
              ssnCtrl.setValidators([ Validators.required, Validators.pattern(/^(?:\d{9}|\d{3}-\d{2}-\d{4})$/)
              ]);
            } else {
              ssnCtrl.setValidators([ Validators.pattern(/^(?:\d{9}|\d{3}-\d{2}-\d{4})$/)
              ]);
            }
            ssnCtrl.updateValueAndValidity({ emitEvent: false });
          }
          const zipCtrl = this.nonEnumeratedIndividualFormPart1.get('neiZip')|| this.nonEnumeratedIndividualFormPart2.get('neiZip');
          if (zipCtrl) {
            if (result.ZipCode) {
              zipCtrl.setValidators([ Validators.required, Validators.pattern(/^\d{5}(?:[-\s]\d{4})?$/) ]);
            } else {
              zipCtrl.setValidators([ Validators.pattern(/^\d{5}(?:[-\s]\d{4})?$/)]);
            }
            zipCtrl.updateValueAndValidity({ emitEvent: false });
          }

        this.isformloaded = true;
        setTimeout(() => {
          this.applyRequiredValidators(result);
          this.cdref.detectChanges();
        }, 50);
      });

    setTimeout(() => {
      const color = localStorage.getItem('primaryCssColor');
      if (color) {
        this.primaryColor = color;
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);
  }

  private applyRequiredValidators(result: any): void {
    const setReq = (group: FormGroup, field: string, required: boolean) => {
      const ctrl = group.get(field);
      if (!ctrl) return;
      if (required) ctrl.addValidators(Validators.required);
      else ctrl.removeValidators(Validators.required);
      ctrl.updateValueAndValidity({ emitEvent: false });
    };

    setReq(this.nonEnumeratedIndividualFormPart1, 'neiAssociatedOrg', !!result.AssociatedOrganizationName);
    setReq(this.nonEnumeratedIndividualFormPart1, 'neiFirstName', !!result.FirstName);
    setReq(this.nonEnumeratedIndividualFormPart1, 'neiLastName', !!result.LastName);
    setReq(this.nonEnumeratedIndividualFormPart1, 'neiDateOfBirth', !!result.DateofBirth);
    setReq(this.nonEnumeratedIndividualFormPart1, 'neiSsn', !!result.SSN);
    setReq(this.nonEnumeratedIndividualFormPart1, 'neiOtherId', !!result.OtherID);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiStreetAddress1', !!result.AddressLine1);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiCity', !!result.City);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiState', !!result.State);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiCounty', !!result.County);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiZip', !!result.ZipCode);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiCountry', !!result.Country);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiPrimaryPhone', !!result.Phone);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiSecondaryPhone', !!result.SecondaryPhone);
    setReq(this.nonEnumeratedIndividualFormPart2, 'neiEmail', !!result.Email);

    if(this.isNameRequired)
        {
        let firstnameVal = this.nonEnumeratedIndividualFormData1.controls.find((x: any) => x.name === 'neiFirstName').value;
        let lastnameVal = this.nonEnumeratedIndividualFormData1.controls.find((x: any) => x.name === 'neiLastName').value;
        let orgnameVal = this.nonEnumeratedIndividualFormData1.controls.find((x: any) => x.name === 'neiAssociatedOrg').value;
        if ((firstnameVal && firstnameVal !== '') || (lastnameVal && lastnameVal !== '') ||
          (orgnameVal && orgnameVal !== '')) {
            this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiFirstName").validators.required = false;
            this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiLastName").validators.required = false;
            this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiAssociatedOrg").validators.required = false;
          }
          else
          {
            this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiFirstName").validators.required = true;
            this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiLastName").validators.required = true;
            this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiAssociatedOrg").validators.required = true;
          }
  
        }

    this.recheckFormValidity();
  }

  private recheckFormValidity(): void {
    const allValid = this.nonEnumeratedIndividualFormPart1.valid && this.nonEnumeratedIndividualFormPart2.valid;
    if (this.isFormsValid !== allValid) {
      this.isFormsValid = allValid;
      this.cdref.detectChanges();
    }
  }

  childInitComplete(): void {
    this.initCount++;
    this.nonEnumeratedIndividualFormPart1.valueChanges.subscribe(() => this.recheckFormValidity());
    this.nonEnumeratedIndividualFormPart2.valueChanges.subscribe(() => this.recheckFormValidity());
    this.recheckFormValidity();
    this.cdref.detectChanges();
    if (this.initCount === 2) {
      this.setupSubscriptions();
    }
  }

  valueChange(data: any) {
    if (data?.name === 'neiState') {
      const abbrev = this.statelist.find(y => y.Id == data.value.target.selectedIndex)?.Abbreviation ?? "";
      this.vendorService.getStateCounties(abbrev).subscribe(result => {
        this.nonEnumeratedIndividualFormData.controls.find((x: any) => x.name == "neiCounty").options =
          result.map(x => ({ value: x.County, key: x.County }));
      });
      this.nonEnumeratedIndividualFormData.controls.find((x: any) => x.name == "neiCounty").disabled = false;
    }
    if (data?.name === 'neiDateOfBirth') {
      this.dobValidation();
    }
    this.formValidate(data);
  }

  formValidate(data: any) {
    this.isFormsValid = this.nonEnumeratedIndividualFormPart1.valid && this.nonEnumeratedIndividualFormPart2.valid && this.dobValidation();
  }

  nonEnumeratedIndividualDetailsSubmit() {
    if (this.isFormsValid) {
      const tempArr = {
        controls: [
          ...this.nonEnumeratedIndividualFormData1.controls,
          ...this.nonEnumeratedIndividualFormData2.controls
        ]
      };
      this.formdata.nonEnumeratedIndividualDetails = tempArr;
      sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
      this.router.navigate(['validateParticipant']);
    }
  }

  back() {
    const tempArr = {
      controls: [
        ...this.nonEnumeratedIndividualFormData1.controls,
        ...this.nonEnumeratedIndividualFormData2.controls
      ]
    };
    this.formdata.nonEnumeratedIndividualDetails = tempArr;
    sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
    this.router.navigate(['referal']);
  }

  openInstruction() {
    const result = this.modalService.open(InstructionsComponent, {
      size: 'lg',
      ariaLabelledBy: 'Instructions'
    });
    result.componentInstance.name = this.instructionText;
  }
   private setupSubscriptions() {
    if (this.isNameRequired) {
      const firstCtrl = this.nonEnumeratedIndividualFormPart1.get('neiFirstName');
      const lastCtrl = this.nonEnumeratedIndividualFormPart1.get('neiLastName');
      const orgCtrl = this.nonEnumeratedIndividualFormPart1.get('neiAssociatedOrg');

      if (firstCtrl && lastCtrl && orgCtrl) {
        this.nameSubscription = merge(
          firstCtrl.valueChanges,
          lastCtrl.valueChanges,
          orgCtrl.valueChanges
        ).subscribe(() => {
          this.updateNameValidators();
        });
      }
    }
    const stateCtrl = this.nonEnumeratedIndividualFormPart2.get('neiState');
    if (stateCtrl) {
      this.stateSubscription = stateCtrl.valueChanges.subscribe((abbr: any) => {
        if (abbr) {
          this.loadCounties(abbr);
        }
      });
    }
    this.formSubscription = merge(
      this.nonEnumeratedIndividualFormPart1.valueChanges,
      this.nonEnumeratedIndividualFormPart2.valueChanges
    ).subscribe(() => {
      this.formValidate(null);
    });

    if (this.isNameRequired) {
      this.updateNameValidators();
    }

    const initialStateValue = stateCtrl?.value;
    if (initialStateValue) {
      this.loadCounties(initialStateValue);
    }
  }

  private loadCounties(abbr: string) {
    this.vendorService.getStateCounties(abbr).subscribe((result: any[]) => {
      const countyConfig = this.nonEnumeratedIndividualFormData.controls.find( (x: any) => x.name === "neiCounty");
      if (!countyConfig) return;
      const counties = result.map(x => ({ key: x.County, value: x.County }));
      countyConfig.options = counties;
      countyConfig.disabled = false;

      setTimeout(() => {
        const countyCtrl = this.nonEnumeratedIndividualFormPart2.get('neiCounty');
        if (countyCtrl) {
          (countyCtrl as any).setValue('');
          countyConfig.value = '';
          countyCtrl.markAsPristine();
          countyCtrl.markAsUntouched();
        }
      }, 0);
    });
  }

    private updateNameValidators() {
    if (!this.isNameRequired) return;

    const firstVal = this.nonEnumeratedIndividualFormPart1.get('neiFirstName')?.value;
    const lastVal = this.nonEnumeratedIndividualFormPart1.get('neiLastName')?.value;
    const orgVal = this.nonEnumeratedIndividualFormPart1.get('neiAssociatedOrg')?.value;

    const hasAny = !!(firstVal || lastVal || orgVal);

    const firstCtrl = this.nonEnumeratedIndividualFormPart1.get('neiFirstName');
    const lastCtrl = this.nonEnumeratedIndividualFormPart1.get('neiLastName');
    const orgCtrl = this.nonEnumeratedIndividualFormPart1.get('neiAssociatedOrg');

    if (hasAny) {
      firstCtrl?.clearValidators();
      lastCtrl?.clearValidators();
      orgCtrl?.clearValidators();

      this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiFirstName").validators.required = false;
      this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiLastName").validators.required = false;
      this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiAssociatedOrg").validators.required = false;
    } else {
      firstCtrl?.setValidators([Validators.required]);
      lastCtrl?.setValidators([Validators.required]);
      orgCtrl?.setValidators([Validators.required]);

      this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiFirstName").validators.required = true;
      this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiLastName").validators.required = true;
      this.nonEnumeratedIndividualFormData1.controls.find((x: { name: string; }) => x.name == "neiAssociatedOrg").validators.required = true;
    }

    firstCtrl?.updateValueAndValidity({ emitEvent: false });
    lastCtrl?.updateValueAndValidity({ emitEvent: false });
    orgCtrl?.updateValueAndValidity({ emitEvent: false });

    this.formValidate(null);
  }

  ngOnDestroy() {
    this.nameSubscription?.unsubscribe();
    this.stateSubscription?.unsubscribe();
    this.formSubscription?.unsubscribe();
  }
  private dobValidation(): boolean {
    let result = true;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dobCfg = this.nonEnumeratedIndividualFormData1.controls.find((x: any) => x.name === 'neiDateOfBirth')
      || this.nonEnumeratedIndividualFormData2.controls.find((x: any) => x.name === 'neiDateOfBirth');

    const dob = dobCfg && dobCfg.value ? new Date(dobCfg.value) : null;
    let err = '';
    if (dob && dob > today) {
      err = 'Date cannot be in the future.';
      result = false;
    }

    const el = document.getElementById('neiDateOfBirth_Error');
    if (el) el.textContent = err;

    const ctrl = this.nonEnumeratedIndividualFormPart1.get('neiDateOfBirth') || this.nonEnumeratedIndividualFormPart2.get('neiDateOfBirth');
    if (ctrl) {
      if (!result) {
        ctrl.setErrors({ ...(ctrl.errors || {}), futureDate: true });
      } else {
        if (ctrl.errors && ctrl.errors['futureDate']) {
          const { futureDate, ...rest } = ctrl.errors;
          Object.keys(rest).length ? ctrl.setErrors(rest) : ctrl.setErrors(null);
        }
      }
    }
    return result;
  }
}
